/**
 * Utility functions for generating unique IDs
 */

/**
 * Generate a unique guitar ID with modern crypto API when available
 */
export function generateGuitarId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `guitar_${crypto.randomUUID()}`;
  }
  
  // Fallback for older browsers - improved collision resistance
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 15);
  const extraRandom = Math.random().toString(36).substring(2, 8);
  return `guitar_${timestamp}_${randomPart}_${extraRandom}`;
}

/**
 * Generate a unique progression ID with modern crypto API when available
 */
export function generateProgressionId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `prog_${crypto.randomUUID()}`;
  }
  
  // Fallback for older browsers - improved collision resistance  
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 15);
  const extraRandom = Math.random().toString(36).substring(2, 8);
  return `prog_${timestamp}_${randomPart}_${extraRandom}`;
}
